
/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  console.log('✅ custom.js loaded — perfume oil GWP mode');

  let gwpInserted = false;
  let lastGWPUpdateTime = 0;
  const GWP_UPDATE_INTERVAL = 2000;

  // 🔧 CONFIG — UPDATE THESE
  const perfumeSignatureId = 371305709591;   // ← signature perfume oil
  const perfumeRoseId = 372068515863;          // ← rose perfume oil
  const gwpVariantId = 44195772497943;         // ← keychain holder cap GWP

  function updateGWPMessage() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const hasPerfume = cart.items.some(item =>
          item.variant_id === perfumeSignatureId ||
          item.variant_id === perfumeRoseId
        );

        const hasGWP = cart.items.some(item =>
          item.variant_id === gwpVariantId
        );

        const hasSubscription = cart.items.some(item => {
          return item.properties && Object.keys(item.properties).some(key =>
            key.toLowerCase().includes('subscription')
          );
        });

        let messageBox = document.querySelector('.gwp-message');

        if (!messageBox && !gwpInserted) {
          const drawerBody = document.querySelector('.cart-drawer__body');
          if (!drawerBody) return;

          messageBox = document.createElement('div');
          messageBox.className = 'gwp-message cart__message';
          messageBox.style.textAlign = 'center';

          drawerBody.prepend(messageBox);
          gwpInserted = true;
        }

        if (!messageBox) return;

        // ✅ qualification logic
        if (hasPerfume && !hasSubscription) {

          if (!hasGWP) {
            messageBox.innerHTML = `
              enjoy a complimentary perfume oil keychain with any perfume oil purchase. must add gift to cart.
              <br>
              <button class="gwp-add-button" style="margin-top:6px;background:#95A929;color:#fff;border:none;padding:8px 12px;cursor:pointer;font-size:14px;">
                add free gift
              </button>
              <div style="font-size:12px;margin-top:4px;">
                gift cannot be combined with other offers.
              </div>
            `;

            const btn = messageBox.querySelector('.gwp-add-button');
            btn?.addEventListener('click', () => maybeAddGWP());

          } else {
            messageBox.textContent =
              "your complimentary perfume oil keychain is in your cart!";
          }

          messageBox.classList.remove('is-hidden');

        } else if (!hasSubscription && !hasGWP) {
          messageBox.innerHTML = `
            enjoy a complimentary perfume oil keychain with any perfume oil purchase. must add gift to cart.
            <div style="font-size:12px;margin-top:4px;">
              gift cannot be combined with other offers.
            </div>
          `;
          messageBox.classList.remove('is-hidden');
        } else {
          // hide if not eligible
          messageBox.classList.add('is-hidden');
        }
      });
  }

  function maybeAddGWP() {
    const btn = document.querySelector('.gwp-add-button');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: gwpVariantId, quantity: 1 }),
    })
    .then(() => setTimeout(updateGWPMessage, 300))
    .catch(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'add free gift';
      }
    });
  }

  window.updateGWPMessage = updateGWPMessage;

  document.addEventListener('DOMContentLoaded', () => {
    updateGWPMessage();

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then(res => {
        const now = Date.now();
        if (args[0].includes('/cart') && now - lastGWPUpdateTime > GWP_UPDATE_INTERVAL) {
          lastGWPUpdateTime = now;
          setTimeout(updateGWPMessage, 120);
        }
        return res;
      });
    };

    document.body.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-drawer-toggle]')) {
        setTimeout(updateGWPMessage, 400);
      }
    });
  });
})();

/* ------------------------------------------------------------
   Klaviyo Footer Newsletter + SMS AJAX Submission
   List ID: XGeeWD
   Company ID: XJ5mQs

   - Submits email + phone to Klaviyo via AJAX
   - Triggers Smart Opt-In for SMS
   - Prevents page redirect
   - Displays inline success / error messages
------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', function () {

  const form = document.getElementById('klaviyo-footer-form');
  if (!form) return;

  const successBox = document.getElementById('klaviyo-success');
  const errorBox = document.getElementById('klaviyo-error');

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    successBox.style.display = 'none';
    errorBox.style.display = 'none';

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const email = form.querySelector('[name="email"]').value.trim();

    let phone = form.querySelector('[name="phone_number"]').value.trim();
    phone = phone.replace(/\D/g, '');

    const consentChecked = form.querySelector('[name="$consent"]').checked;

    const payload = new URLSearchParams({
      g: 'XGeeWD',
      company_id: 'XJ5mQs',
      email: email
    });

    if (phone !== '') {
      payload.append('phone_number', phone);
    }

    if (consentChecked) {
      payload.append('$consent', 'SMS');
    }

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: payload.toString()
    })
    .then(response => response.json())
    .then(data => {

      if (data && data.success) {
        form.reset();
        successBox.style.display = 'block';
      } else {
        errorBox.style.display = 'block';
        console.warn('Klaviyo error:', data);
      }

    })
    .catch(error => {
      errorBox.style.display = 'block';
      console.error('Submission error:', error);
    });

  });

});